import React from "react";
import KioskLayout from "components/Layout/KioskLayout";
import EventList from "components/Kiosk/Event/EventList";
import EventFeature from "components/Kiosk/Event/EventFeature";
import useFetch from "hooks/useFetch";
import useGaPageView from "hooks/useGaPageView";
import { mainApiPath } from "api/constants";
import FilterSection from "components/shared/FilterSection";
import { screenKeys, gaSettings } from "config/constants";
import { useSelector } from "react-redux";
import languages from "languages/languages";

const KioskPromotion = (props) => {
  const [error, loading, data] = useFetch(mainApiPath.promotion);
  const langState = useSelector((state) => state.language.lang);
  const title = languages[langState]["Ưu đãi nổi bật"];
  const titleButton = languages[langState]["Chỉ đường đến gian hàng"];
  const noEvent = languages[langState]["Không có promotion"];

  const gaTitle = gaSettings.promotion.title;
  const gaLocation = gaSettings.promotion.location;
  useGaPageView({gaTitle, gaLocation});

  return (
    <KioskLayout
      error={error}
      loading={loading}
      goBack={screenKeys.kiosk}
      left={
        <>
          <EventFeature
            features={data ? data.features : null}
            loading={loading}
            title={title}
          />
          <FilterSection
            floors={data ? data.floors : null}
            search
            floorfilter
            loading={loading}
          />
        </>
      }
      right={
        <EventList
          events={data ? data.list : null}
          loading={loading}
          apiPath={mainApiPath.promotion}
          titleButton={titleButton}
          noEvent={noEvent}
        />
      }
    />
  );
};

export default KioskPromotion;
